import { render, staticRenderFns } from "./TherapistProfileModals.vue?vue&type=template&id=a1a2f0bc"
import script from "./TherapistProfileModals.vue?vue&type=script&lang=js"
export * from "./TherapistProfileModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports